import { Component, HostListener, inject } from '@angular/core';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-scroll-to-top-button',
  imports: [],
  templateUrl: './scroll-to-top-button.component.html',
  styleUrls: ['./scroll-to-top-button.component.scss']
})
export class ScrollToTopButtonComponent {

  private readonly viewportScroller = inject(ViewportScroller);

  public isVisible: boolean = false;

  @HostListener('window:scroll', [])
  public onWindowScroll(): void {
    let scrollPosition = this.viewportScroller.getScrollPosition();
    this.isVisible = scrollPosition[1] > 300;
  }

  public scrollToTop(): void {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}